export const PersonDebtTypes = {
  SHOW_APARTMENT_PERSON_DEBT: "SHOW_APARTMENT_PERSON_DEBT",
  ADD_PERSON_DEBT: "ADD_PERSON_DEBT",
};
